import { BlobServiceClient, ContainerClient } from "@azure/storage-blob";

const connectionString =
    "DefaultEndpointsProtocol=https;AccountName=dssstorageaccountprod01;AccountKey=11Th42H42gyWO7Lwo2TKYz9nn4miBlOl26kZ2+ag1TNo3K6H2KHQTdD38fS+Mga8fWJTdi4QhyNS/F2VyFT/Gg==;EndpointSuffix=core.windows.net"; // Change this to environment variable

const containerName = "user-image-storage";

const blobSasUrl = "https://dssstorageaccountprod01.blob.core.windows.net/user-image-storage?sp=racwdli&st=2025-04-07T19:44:41Z&se=2029-12-30T23:00:00Z&spr=https&sv=2024-11-04&sr=c&sig=2wyha5%2FPsWcFES9dQ99OySkxm%2BMvU5Ig1XWZSQH0i%2B8%3D"

function getBlobServiceClient(): BlobServiceClient {
    return new BlobServiceClient(blobSasUrl);
}


export async function uploadImageToBlobStorage(
    fileName: string,
    fileData: Uint8Array
): Promise<void> {
    const blobServiceClient = getBlobServiceClient();
    const containerClient: ContainerClient =
        blobServiceClient.getContainerClient(containerName);
    const blockBlobClient = containerClient.getBlockBlobClient(fileName);

    try {
        await blockBlobClient.uploadData(fileData);
        console.log("Image uploaded successfully!");
    } catch (error) {
        console.error("Error uploading image:", error);
    }
}

export async function downloadImageFromBlobStorage(
    fileName: string
): Promise<Uint8Array> {
    const blobServiceClient = getBlobServiceClient();
    const containerClient: ContainerClient =
        blobServiceClient.getContainerClient(containerName);
    const blockBlobClient = containerClient.getBlockBlobClient(fileName);

    try {
        const downloadBlockBlobResponse = await blockBlobClient.download(0);
        if (!downloadBlockBlobResponse.blobBody) {
            throw new Error("No data in blobBody");
        }

        const blobData = await downloadBlockBlobResponse.blobBody;
        const arrayBuffer = await blobData.arrayBuffer();
        const fileData = new Uint8Array(arrayBuffer);

        console.log("Image downloaded successfully!");
        return fileData;
    } catch (error) {
        console.error("Error downloading image:", error);
        return new Uint8Array();
    }
}

export async function deleteImageFromBlobStorage(
    fileName: string
): Promise<void> {
    const blobServiceClient = getBlobServiceClient();
    const containerClient: ContainerClient =
        blobServiceClient.getContainerClient(containerName);
    const blockBlobClient = containerClient.getBlockBlobClient(fileName);

    try {
        await blockBlobClient.delete();
        console.log("Image deleted successfully!");
    } catch (error) {
        console.error("Error deleting image:", error);
    }
}

export async function deleteImagesStartingWith(prefix: string): Promise<void> {
    const blobServiceClient = getBlobServiceClient();
    const containerClient: ContainerClient =
        blobServiceClient.getContainerClient(containerName);
    try {
        for await (const blob of containerClient.listBlobsFlat({
            prefix,
        })) {
            const blockBlobClient = containerClient.getBlockBlobClient(
                blob.name
            );
            await blockBlobClient.delete();
            console.log(`Deleted blob with name: ${blob.name}`);
        }
    } catch (error) {
        console.error("Error deleting images:", error);
    }
}
